module.exports = __webpack_public_path__ + "media/images/icon__link@3x-3986d9f15808e3b33e83253252db1022.png";